import { render, staticRenderFns } from "./resourceVideo2.vue?vue&type=template&id=1acebb3e&scoped=true"
import script from "./resourceVideo2.vue?vue&type=script&lang=js"
export * from "./resourceVideo2.vue?vue&type=script&lang=js"
import style0 from "./resourceVideo2.vue?vue&type=style&index=0&id=1acebb3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acebb3e",
  null
  
)

export default component.exports